<template>
  <transition name='fade'>
    <div class="modal video_view"
         v-if='visible'>
      <div class="video_view_content">
        <div class="video_view_title msp_icon_close">
          <span>{{pictureInfo.title}}</span>
          <span class="iconfont el-icon-close"
                @click.stop='closeBox()'></span>
        </div>
        <el-image style="width: 600px; height: 400px;margin-left:100px;margin-top:50px;"
                  :src="pictureInfo.url"
                  :alt='alt'
                  :fit="fit">
          <div slot="error"
               class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'previewPicture',
  data() {
    return {
      visible: false,
      pictureInfo: '',
      fit: 'contain',
      alt: '图片加载失败'
    }
  },
  mounted() {
    this.$root.eventHub.$on('previewPictureModel', (data) => {
      this.visible = true
      this.pictureInfo = data
    })


  },
  destroyed() {
    this.$root.eventHub.$off('previewPictureModel')
  },
  components: {

  },
  methods: {
    closeBox() {
      this.visible = false
    },

  },
  watch: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/preview.styl'
</style>
